module.exports = __webpack_public_path__ + "img/image-1.f0fc5d26.png";